import { Option } from 'components/Forms/MultiSelectField';
import { TypeFilter } from 'store/shoppingCart/types';
import { TYPE_FILTER_OPTIONS } from './constants';

type OptionAdapter = (value: Option[], name: string) => Option[];

const TYPE_FILTER_LEAF_OPTIONS = TYPE_FILTER_OPTIONS.flatMap(group => group.options);

// Both sides take a missing value: the cart stores null for "show every option", a new
// cart has none yet, and react-select emits null once the last chip is removed.
export const toTypeFilterOptions = (value: TypeFilter[] | null | undefined) =>
  TYPE_FILTER_LEAF_OPTIONS.filter(option => (value ?? []).includes(option.value as TypeFilter));

export const toTypeFilters = (options: Option[] | null) =>
  (options ?? []).map(option => option.value as TypeFilter);

// MultiSelectField's format/parse are typed Option[] -> Option[] (it has no separate
// stored-value generic); these bridge to the real TypeFilter[] the payload needs.
export const formatTypeFilters = toTypeFilterOptions as unknown as OptionAdapter;
export const parseTypeFilters = toTypeFilters as unknown as OptionAdapter;
